import {StyleSheet} from "react-native";
import {styleVars} from "../../app-style-vars";

export default StyleSheet.create({
  uploaderTitle: {
    fontSize: styleVars.rem(1.25),
    fontWeight: 'bold',
    paddingBottom: styleVars.rem(.5),
  },
  subtitle: {
    fontWeight: 'bold',
  },
  subtitleWrapper: {
    marginVertical: styleVars.rem(.5),
  },
  uploadControlsContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  uploadButtonContainer: {
    paddingHorizontal: styleVars.rem(1),
    paddingVertical: styleVars.rem(.5),
    maxWidth: '75%',
  },
  uploadButton: {
    padding: styleVars.rem(.5),
    borderWidth: 1,
    borderColor: styleVars.boschDarkBlue,
    backgroundColor: styleVars.boschDarkBlue,
  },
  uploadButtonDisabled: {
    backgroundColor: styleVars.boschLightGray,
    borderColor: styleVars.boschLightGray,
  },
  uploadButtonText: {
    color: '#fff',
    fontSize: styleVars.rem(.875),
    textAlign: 'center',
  },
  uploadButtonTextDisabled: {
    color: styleVars.boschLightGrayW75,
  },
  cancelButtonContainer: {
    padding: styleVars.rem(.5),
  },
  cancelUploadButton: {
    padding: styleVars.rem(.5),
  },
  cancelUploadButtonText: {
    color: styleVars.boschDarkBlue,
    fontSize: styleVars.rem(.875),
    textAlign: 'center',
  },
  picker: {
    borderColor: styleVars.boschLightGray,
    borderWidth: 1,
    height: styleVars.rem(2.5),
    backgroundColor: '#fff',
  },
  pickerWithError: {
    borderColor: styleVars.boschRed,
  },
  textarea: {
    height: styleVars.rem(4),
    borderColor: styleVars.boschLightGray,
    borderWidth: 1,
    padding: styleVars.rem(.25),
  },
  textareaDisabled: {
    opacity: 0.7,
    cursor: 'default',
  },
  textareaWithError: {
    borderColor: styleVars.boschRed,
  },
  asterix: {
    color: styleVars.boschRed,
  },
  withSeparator: {
    paddingTop: styleVars.rem(1),
    marginTop: styleVars.rem(.5),
    borderTopWidth: 1,
    borderTopColor: styleVars.boschLightGray,
  },
})